import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { LegacyCronJobComponent } from './legacy-cron-job.component';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
    ],
    declarations: [LegacyCronJobComponent],
    exports: [
        LegacyCronJobComponent,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class LegacyCronJobModule {}
